<template>
  <div>
    <div class="title">
      <span
        style="
          width: 85%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          text-align: left;
        "
        >{{ hotelBrand }} Digital Assistant</span
      >
      <svg
        t="1757665900240"
        class="icon"
        @click="goHome"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="5657"
        width="17"
        height="17"
      >
        <path
          d="M867.648 951.296 512 595.648l-355.648 355.648c-11.52 11.52-30.272 11.52-41.856 0L72.64 909.44c-11.52-11.52-11.52-30.272 0-41.856L428.352 512 72.64 156.352c-11.52-11.52-11.52-30.272 0-41.856l41.856-41.856c11.52-11.52 30.272-11.52 41.856 0L512 428.288l355.648-355.648c11.52-11.52 30.272-11.52 41.856 0l41.856 41.856c11.52 11.52 11.52 30.272 0 41.856L595.648 512l355.648 355.648c11.52 11.52 11.52 30.272 0 41.856l-41.856 41.856C897.984 962.88 879.168 962.88 867.648 951.296L867.648 951.296z"
          p-id="5658"
          fill="#707070"
        ></path>
      </svg>
    </div>
    <iframe
      :src="roomUrl"
      class="iframe"
      width="100%"
      frameborder="0"
      allowfullscreen
    ></iframe>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import { getAction, deleteAction, putAction, postAction } from "@/api/manage";
export default {
  data() {
    return {
      url: {
        createRoom: "/api/message/createTextBotRoom",
      },
      matrixBaseUrl: "https://hvtchat.hotelservicebot.com",
      // matrixBaseUrl: "http://10.16.39.222:8082",
      roomId: "",
      roomUrl: "", // 房间的可访问URL
      plateformAccessToken: "",
      userId: "",
      hotelId: Vue.ls.get("hotelId"),
      hotelName: Vue.ls.get("hotelName"),
      hotelBrand: Vue.ls.get("hotelBrand"),
    };
  },
  async created() {
    this.tsp = this.$route.query.tsp;
    let now = new Date().getTime();
    console.log(now - this.tsp * 1000);
    if (now - this.tsp * 1000 > 1000 * 60 * 60 * 24) {
      this.loading.clear();
      //如果是走了这个about 后台调用一下接口 打log
      getAction(this.url.about).then((res) => {});
      this.$router.push({ name: "About" });
    }
  },
  mounted() {
    // 页面加载完成后自动执行创建逻辑
    this.createMatrixRoom();
    // 给html和body添加临时样式
    document.documentElement.style.overscrollBehavior = "none";
    document.body.style.overscrollBehavior = "none";
  },
  // 页面离开时移除样式，恢复全局设置
  beforeDestroy() {
    // 移除临时样式，避免影响其他页面
    document.documentElement.style.overscrollBehavior = "";
    document.body.style.overscrollBehavior = "";
  },
  methods: {
    createMatrixRoom() {
      let param = {
        name: Vue.ls.get("room") ? Vue.ls.get("room") : "",
        topic: "",
        hotelNo: this.$route.query.inno,
      };
      postAction(this.url.createRoom, param).then((r) => {
        if (r.status == "0") {
          this.roomId = r.data.roomId;
          this.plateformAccessToken = r.data.token;
          this.userId = r.data.userId;
          this.generateRoomUrl();
        }
      });
    },
    /**
     * 生成房间的可访问URL
     * @param {string} roomId 房间ID
     * @returns {string} 房间URL
     */
    generateRoomUrl() {
      this.roomUrl = `${this.matrixBaseUrl}/?username=${
        this.userId
      }&password=123456&hotelId=${this.hotelId}&plateformAccessToken=
            ${this.plateformAccessToken}&roomId=${encodeURIComponent(
        this.roomId
      )}&roomType=guestChat`;
      console.log(this.roomUrl);
    },
    goHome() {
      let query = {};
      query.type = this.$route.query.type;
      query.inno = this.$route.query.inno;
      if (this.$route.query.room) {
        query.room = this.$route.query.room;
      }
      if (this.$route.query.building) {
        query.building = this.$route.query.building;
      }
      query.tsp = this.$route.query.tsp;
      this.$router.push({ name: "Home", query: query });
    },
  },
};
</script>
<style lang="scss">
.title {
  padding: 10px 20px;
  color: $primary-color;
  font-size: 17px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
}
.iframe {
  height: calc(100vh);
}

/* 确保页面内容可正常滚动 */
html {
  -webkit-overflow-scrolling: touch;
}
</style>
